import { Progress, Space, Tag, Typography } from 'antd';
import React, { FC } from 'react';
import Link from 'antd/lib/typography/Link';
import { ProgressConfigValue } from '../ProgressConfigInput/ProgressConfigInput';
const { Text } = Typography;

export type Props = {
  item: any;
  onClick: () => void;
};

const KeyResultCard: FC<Props> = (props) => {
  const { item } = props;
  return (
    <Link onClick={() => props.onClick()}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
          padding: '15px 20px',
          justifyContent: 'center',
          borderRadius: 5,
          marginBottom: '2%',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}>
          <Space>
            <Text style={{ color: 'black' }}>
              {item?.title === '' ? `Enter Title` : item?.title}
            </Text>
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="blue">
              {item?.progress?.type}
            </Tag>
          </Space>
          <div>
            <ProgressConfigValue value={{ ...item.progress }} />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '50%',
          }}>
          <Progress
            percent={+item?.completed ?? 0}
            style={{ marginRight: 20 }}
            strokeColor={
              item?.status === 'Completed'
                ? 'green'
                : item?.status === 'Pending'
                ? 'blue'
                : item?.status === 'On-hold'
                ? 'cyan'
                : item?.status === 'Offtrack'
                ? 'red'
                : item?.status === 'Ontrack'
                ? '#f4d03f'
                : ''
            }
          />
          {item?.status == 'Pending' ? (
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="blue">
              Pending
            </Tag>
          ) : item?.status == 'Not Started' ? (
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="">
              Not Started
            </Tag>
          ) : item?.status == 'Ontrack' ? (
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="yellow">
              Ontrack
            </Tag>
          ) : item?.status == 'On-hold' ? (
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="cyan">
              On-hold
            </Tag>
          ) : item?.status == 'Offtrack' ? (
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="red">
              Offtrack
            </Tag>
          ) : (
            <Tag style={{ alignItems: 'center', display: 'flex' }} color="green">
              Completed
            </Tag>
          )}
        </div>
      </div>
    </Link>
  );
};

export default KeyResultCard;
